import { DashboardsComponent } from './../../dashboards/dashboards.component';
import { DashboardV2Component } from '../../dashboard-v2/dashboard-v2.component';
import { AuthGuard } from './../../../services/auth.guard';
import { AppointmentsComponent } from './../../appointments/appointments.component';
import { Routes } from '@angular/router';
import { DiagnosticiansComponent } from '../../diagnosticians/diagnosticians.component';
import { DirectorsComponent } from '../../directors/directors.component';
import { CreateUserComponent } from '../../create-user/create-user.component';
import { CompletedAppointmentsComponent } from '../../completed-appointments/completed-appointments.component';
import { CancelledAppointmentComponent } from '../../cancelled-appointment/cancelled-appointment.component';
import { AvailabilityComponent } from '../../availability/availability.component';
import { ViewAllComponent } from '../../view-all/view-all.component';
import { ClientAppointmentDetailComponent } from '../../client-appointment-detail/client-appointment-detail.component';
import { FollowUpComponent } from '../../follow-up/follow-up.component';
import { StudentObservationComponent } from '../../student-observation/student-observation.component';
import { AppointmentAllDetailsComponent } from '../../appointment-all-details/appointment-all-details.component';
import { PaymentsComponent } from '../../payments/payments.component';
import { AdminsComponent } from '../../admins/admins.component';
import { CreateAdminUserComponent } from '../../create-admin-user/create-admin-user.component';
import { TodaysAppointmentComponent } from '../../todays-appointment/todays-appointment.component';
import { UpcomingAppointmentComponent } from 'src/app/upcoming-appointment/upcoming-appointment.component';
import { InprogressAppointmentComponent } from 'src/app/inprogress-appointment/inprogress-appointment.component';
import { RescheduleAppointmentsComponent } from '../../reschedule-appointments/reschedule-appointments.component';
import { RescheduleFollowUpComponent } from '../../reschedule-follow-up/reschedule-follow-up.component';
import { ReassignComponent } from '../../reassign/reassign.component';
import { DiagAvailabiltyComponent } from '../../diag-availabilty/diag-availabilty.component';
import { HoldReportComponent } from '../../hold-report/hold-report.component';
import { ViewAllV2Component } from '../../view-all-v2/view-all-v2.component';
import { UpcomingAppointmentV2Component } from 'src/app/upcoming-appointment-v2/upcoming-appointment-v2.component';
import { InprogressAppointmentV2Component } from 'src/app/inprogress-appointment-v2/inprogress-appointment-v2.component';
import { CompletedAppointmentsV2Component } from '../../completed-appointments-v2/completed-appointments-v2.component';
import { CancelledAppointmentsV2Component } from '../../cancelled-appointments-v2/cancelled-appointments-v2.component';
import { HoldReportV2Component } from '../../hold-report-v2/hold-report-v2.component';
import { PaymentsV2Component } from '../../payments-v2/payments-v2.component';
import { AdminsV2Component } from '../../admins-v2/admins-v2.component';
import { DiagnosticiansV2Component } from '../../diagnosticians-v2/diagnosticians-v2.component';
import { DirectorsV2Component } from '../../directors-v2/directors-v2.component';
import { AppAppointmentAllDetailsV2Component } from '../../app-appointment-all-details-v2/app-appointment-all-details-v2.component';
import { AnalyticsComponent } from '../../analytics/analytics.component';


export const CommonLayoutRoutes: Routes = [
  {
   
    path: 'dashboard',
    //component: DashboardsComponent,
     component: DashboardV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'analytics',
    component: AnalyticsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
  path: 'dashboard-old',
    component: DashboardsComponent,
    // component: DashboardV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  
  {
    path: 'view',
   // component: ViewAllComponent,
     component:  ViewAllV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'view-old',
    component: ViewAllComponent,
   //  component:  ViewAllV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  
  {
    path: 'complete',
    component: CompletedAppointmentsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: 'complete-old',
    component: CompletedAppointmentsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  
  {
    path: 'review',
    component: AppointmentsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'todays',
    component: TodaysAppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'cancelled-old',
    component: CancelledAppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: 'cancelled',
    component: CancelledAppointmentsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  
  {
    path: 'diagnosticians',
    component: DiagnosticiansV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'diagnosticians-old',
    component: DiagnosticiansComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'create-user',
    component: CreateUserComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'directors',
    component: DirectorsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'directors-old',
    component: DirectorsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'availability',
    component: AvailabilityComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'directorAvailability',
    component: DiagAvailabiltyComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'inprogres',
    component: InprogressAppointmentV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: 'inprogres-old',
    component: InprogressAppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  

  {
    path: 'upcoming',
    component: UpcomingAppointmentV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: 'upcoming-old',
    component: UpcomingAppointmentComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  {
    path: 'view-apointment-info/:appointmentId',
    component: ClientAppointmentDetailComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'followup',
    component: FollowUpComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'student-observation/:id/:draft',
    component: StudentObservationComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'appt-all-details/:id',
    component: AppAppointmentAllDetailsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  
  {
    path: 'appt-all-details-old/:id',
    component: AppointmentAllDetailsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'reschedule-appointments/:id',
    component: RescheduleAppointmentsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'reschedule-follow-up/:id',
    component: RescheduleFollowUpComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'payment-old',
    component: PaymentsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'payment',
    component: PaymentsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  
  {
    path: 'admin',
    component: AdminsV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'admin-old',
    component: AdminsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'create-admin',
    component: CreateAdminUserComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 're-assign/:id',
    component: ReassignComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'hold-old',
    component: HoldReportComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'hold',
    component: HoldReportV2Component,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },

  

];
